import React from "react";
import { cn } from "../lib/utils";
import { Skeleton } from "./Skeleton";

const SkeletonCard = ({
  imageClass = "",
  titleClass = "",
  descriptionClass = "",
  containerClass = "",
}) => {
  return (
    <div className={cn("flex flex-col space-y-3", containerClass)}>
      <Skeleton className={cn("h-[125px] w-[250px] rounded-xl", imageClass)} />
      <div className="space-y-2">
        <Skeleton className={cn("h-4 w-[250px]", titleClass)} />
        <Skeleton className={cn("h-4 w-[200px]", descriptionClass)} />
      </div>
    </div>
  );
};

export default SkeletonCard;
